import axios from "axios";
import { API } from "./api";

const h = (passcode) => ({ headers: { "x-admin-passcode": passcode } });

export const assetUrl = (u) =>
  !u ? "" : u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`;

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const getShopProducts = async () => (await axios.get(`${API}/shop/products`)).data;
export const getShopConfig = async () => (await axios.get(`${API}/shop/config`)).data;
export const getShippingQuote = async (payload) =>
  (await axios.post(`${API}/shop/shipping-quote`, payload)).data;
export const startCheckout = async (payload) =>
  (await axios.post(`${API}/shop/checkout`, payload)).data;
export const getOrderStatus = async (sessionId) =>
  (await axios.get(`${API}/shop/orders/status/${sessionId}`)).data;

export const adminShop = {
  status: async (p) => (await axios.get(`${API}/admin/shop/status`, h(p))).data,
  saveSettings: async (body, p) => (await axios.put(`${API}/admin/shop/settings`, body, h(p))).data,
  connectWebhook: async (site_url, p) =>
    (await axios.post(`${API}/admin/shop/printful/connect-webhook`, { site_url }, h(p))).data,
  products: async (p) => (await axios.get(`${API}/admin/shop/products`, h(p))).data,
  createProduct: async (body, p) => (await axios.post(`${API}/admin/shop/products`, body, h(p))).data,
  updateProduct: async (id, body, p) =>
    (await axios.put(`${API}/admin/shop/products/${id}`, body, h(p))).data,
  deleteProduct: async (id, p) => (await axios.delete(`${API}/admin/shop/products/${id}`, h(p))).data,
  uploadImage: async (id, file, p) => {
    const form = new FormData();
    form.append("file", file);
    return (await axios.post(`${API}/admin/shop/products/${id}/images`, form, h(p))).data;
  },
  printfulProducts: async (p) => (await axios.get(`${API}/admin/shop/printful/products`, h(p))).data,
  importPrintful: async (syncId, p) =>
    (await axios.post(`${API}/admin/shop/printful/import/${syncId}`, {}, h(p))).data,
  orders: async (p) => (await axios.get(`${API}/admin/shop/orders`, h(p))).data,
  retryPrintful: async (id, p) =>
    (await axios.post(`${API}/admin/shop/orders/${id}/retry-printful`, {}, h(p))).data,
  refreshPrintful: async (id, p) =>
    (await axios.post(`${API}/admin/shop/orders/${id}/refresh-printful`, {}, h(p))).data,
  pmPlaced: async (id, body, p) =>
    (await axios.post(`${API}/admin/shop/orders/${id}/printed-mint-placed`, body, h(p))).data,
  pmShipped: async (id, body, p) =>
    (await axios.post(`${API}/admin/shop/orders/${id}/printed-mint`, body, h(p))).data,
};

export const errMsg = (e, fallback = "Something went wrong.") =>
  e?.response?.data?.detail || fallback;
